module.exports = __webpack_public_path__ + "static/media/UserCircleHover.5ef2dc75.svg";